import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/restricted/restricted.module').then(
        (m) => m.RestrictedModule
      ),
  },
  {
    path: 'downtime',
    loadComponent: () =>
      import('@coin-depo-ui/components/system/temporary-downtime')
        .then(m => m.TemporaryDowntimeComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('@coin-depo-ui/components/system/not-found404')
        .then(m => m.NotFound404Component),
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],

  exports: [RouterModule],
})
export class AppRoutingModule {
}
